/** * * Asynchronously loads the component for
Service Plans
* */ import { lazyLoad } from "utils/loadable";
export const ServicePlans = lazyLoad(
  () => import("./index"),
  (module) => module.ServicePlans
);